import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Root,
  voices: {
    main: {
      description:
        "ancient tree-creature bass, slow wooden creaks in a gentle giant throat, few words with huge emotional shifts, earthy breath, warm hollow resonance",
      seed: 10073,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "I am Root." },
      { id: "select_2", text: "I am Root!" },
    ],
    spawn: [
      { id: "spawn_1", text: "I am Root." },
      { id: "spawn_2", text: "I am Root!" },
      { id: "spawn_3", text: "I am Root~" },
      { id: "spawn_4", text: "I am… Root!" },
    ],
    respawn: [
      { id: "respawn_1", text: "I am Root!" },
      { id: "respawn_2", text: "Root!" },
    ],
    ult_ally: [{ id: "ult_ally", text: "We are Root!" }],
    ult_enemy: [{ id: "ult_enemy", text: "I AM GROOOOT!!!" }],
    ability2: [{ id: "ability2", text: "I am Root!" }],
    kill: [
      { id: "kill_1", text: "(triumphant roar)" },
      { id: "kill_2", text: "I am Root!!!" },
      { id: "kill_3", text: "I am Root!" },
    ],
    low_hp: [{ id: "low_hp", text: "I am Root!" }],
    healed: [
      { id: "healed_1", text: "I am Root!" },
      { id: "healed_2", text: "Root!" },
    ],
  },
} satisfies VoiceScript;

export default script;
